import { BlueprintInstanceType, type ReferenceMap } from '@rta/rta-blueprint-library';

import { applianceGroupMenuList, applianceMenuList, backsplashMenuList, breakpointMenuList, centerMarkerMenuList, cornerMenuList, countertopMenuList, customPanelMenuList, customPanelPageMenuList, defaultMenuList, dimensionMenuList, obstructionMenuList, panelMenuList, spacerMenuList, workspaceMenuList } from './menu-list';
import { ComponentController, DisplayMode } from '@r-core';
import { type ContextMenuData, type	ContextMenuList, ReferenceEntryType } from './types';

export type GetContextMenuList = {
	displayMode: DisplayMode,
	data: ContextMenuData,
	refMap: null | ReferenceMap,
	controller: ComponentController
};

export const getContextMenuList = ({ data, displayMode, controller, refMap }: GetContextMenuList): Array<ContextMenuList> => {
	let menuList: Array<ContextMenuList> = null;

	switch (data.context.menuKey) {
		case BlueprintInstanceType.PanelItem:
			menuList = refMap?.panelItem?.item.category?.isSpacer ? spacerMenuList : applianceMenuList;
			break;
		case BlueprintInstanceType.PanelItemGroup:
			menuList = applianceGroupMenuList;
			break;
		case BlueprintInstanceType.Corner:
			menuList = cornerMenuList;
			break;
		case BlueprintInstanceType.Countertop:
			menuList = countertopMenuList;
			break;
		case BlueprintInstanceType.Dimension:
			menuList = dimensionMenuList;
			break;
		case BlueprintInstanceType.Obstruction:
			menuList = obstructionMenuList;
			break;
		case BlueprintInstanceType.Panel:
			menuList = panelMenuList;
			break;
		case BlueprintInstanceType.Backsplash:
			menuList = backsplashMenuList;
			break;
		case BlueprintInstanceType.Breakpoint:
			menuList = breakpointMenuList;
			break;
		case ReferenceEntryType.CustomPanel:
			menuList = customPanelMenuList;
			break;
		case ReferenceEntryType.CustomPanelPage:
			menuList = customPanelPageMenuList;
			break;
		case ReferenceEntryType.CenterMarker:
			menuList = centerMarkerMenuList;
			break;
		default:
			menuList = workspaceMenuList;
	}

	return [
		...defaultMenuList,
		...(menuList.filter((menuItem) => {
			return (typeof menuItem.displayModes === 'undefined' ||	menuItem.displayModes.indexOf(displayMode) !== -1) &&
				(typeof menuItem.isVisible === 'undefined' ||
					(typeof menuItem.isVisible === 'boolean' && menuItem.isVisible) ||
					(typeof menuItem.isVisible === 'function' && menuItem.isVisible({ context: data.context, refMap, controller }))
				)
		}))
	];
}
